const messages = {
  "title": "Investment support",
  "description": "Bridgestone also supports you individually in your business investments. Whether for the purchase of machines or workshop equipment, for workshop replacement vehicles or also for marketing activities such as advertising or online banner placements, etc. - use your BRIDGESTONE PLUS bonus points to refinance your investments. Simply submit the invoice from the respective supplier here after the investment and indicate how many of your bonus points you would like to use here. Follow the instructions described below.",
  "description_old": "Investment support for workshop equipment Advertising grant for marketing projects",
  "info": {
    "paragraph2_old": "Bring your workshop equipment or sales area up to date or advertise to better market your products. Please tell us the points value that you would like to contribute for this prize. The minimum points expenditure is 1,250 points. Value per point = 0.25 EUR",
    "paragraph2": "You implement your desired investment and settle the invoice from the third-party provider.",
    "paragraph3_old": "To invoice the prize, we need your invoice for the amount of the redeemed points (number of points x 0.25 EUR = net invoice amount) and a copy of the original invoice. You can find a sample invoice",
    "paragraph3": "Finally, you submit the application for funding here on this page in the request field on the right",
    "paragraph4_old": "We ask you to contact us personally to initiate the next steps."
  },
  "excludeText": "Please understand that investments in direct competitive offers are excluded.",
  "here": "here",
  "contactPerson": "Contact person",
  "email": "Email",
  "phone": "Tel",
  "payInfo": "Payment may take up to 8 weeks!"
};

export default {
  messages,
};
